import styled from 'styled-components'
import NameBox from '../../atoms/NameBox'

export const Container = styled.div`
  width: 100%;
`
export const ParentDiv = styled.div`
  width: 80%;
  margin: 0 auto;
  gap: 10px;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const ChildDiv = styled.div`
  gap: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
`

export const Details = styled.div`
  list-style-type: circle;
  margin: 0 auto 0 auto;
  display: flex;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  padding: 2rem;
  text-decoration: underline;
`

export const HeadingStyled = styled.h1`
  letter-spacing: 1px;
  text-align: center;
  margin: 1em;
  font-size: 2rem;
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`
export const LabelStyled = styled.label`
  display: inline-block;
  font-size: 1.2rem;
  width: 20%;
  font-weight: 600;
  color: #000;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  flex: 3;
  @media (max-width: 1024px) {
    font-size: 1rem;
    width: 40%;
    font-weight: 400;
    padding: 10px;
  }
`
export const InputStyled = styled.input`
  background: #e8f0f7;
  border: none;
  outline: none;
  width: 70%;
  font-size: 1.2rem;
  padding: 20px;
  color: #000;
  border-radius: 5px;
  @media (max-width: 1024px) {
    font-size: 1rem;
    font-weight: 600;
    padding: 10px;
    width: 55%;
  }
  @media (max-width: 768px) {
    font-weight: 400;
  }
`
export const TableStyled = styled.table`
  margin: 0 auto;
  padding: 1rem;
  margin-top: 3rem;
  @media (max-width: 768px) {
    padding: 0;
  }
  th {
    font-size: 1.2rem;
    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }
  tbody tr td {
    padding: 10px;
    font-size: 1rem;
    border-bottom: 1px solid #e0e0e0;

    @media (max-width: 1024px) {
      padding: 0;
    }
  }
`
export const InputTableStyled = styled(InputStyled)`
  width: 100%;
`
export const Button = styled.button`
  display: flex;
  width: 30%;
  justify-content: center;
  padding: 0.75rem 1rem;
  border-radius: 5px;
  font-weight: bold;
  background: #2d60ff;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  padding: 20px;
  margin: 1rem auto;
  @media (max-width: 768px) {
    width: 90%;
  }
`
export const IconStyled = styled.div`
  width: 3%;
  @media (max-width: 768px) {
    display: none;
  }
`
export const TableDataStyled = styled.td`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
`
export const NameBoxStyled = styled(NameBox)`
  @media (max-width: 1024px) {
    display: none;
  }
`
